export default __webpack_public_path__ + "static/media/P310.97ca21c7.pdf";